import { Link, Typography } from '@mui/material';
import { MeetingBookingStatus, NoteTakerStatus } from 'generated-graphql/types';
import { useConversationDetailsTab } from 'modules/conversations/atoms/tabsAtom';
import { ConversationDetailsTabs } from 'modules/conversations/constants/conversationDetailsTabs';

type Props = {
  status: MeetingBookingStatus | null | undefined;
  noteTakerStatus: NoteTakerStatus | null | undefined;
  onOpenDrawer: () => void;
};

export const MeetingDetailsActions: React.FC<Props> = ({
  status,
  noteTakerStatus,
  onOpenDrawer
}) => {
  const { setSelectedTab } = useConversationDetailsTab();

  if (status === MeetingBookingStatus.Cancelled) {
    return (
      <Typography
        sx={{
          fontSize: '14px',
          color: 'error.main'
        }}
      >
        Cancelled
      </Typography>
    );
  }

  if (noteTakerStatus === NoteTakerStatus.Available) {
    return (
      <Link
        onClick={() => setSelectedTab(ConversationDetailsTabs.MeetingNotes)}
        href="#"
        sx={{
          fontSize: '14px',
          color: 'customGrey.main',
          textDecoration: 'none'
        }}
      >
        View meeting notes
      </Link>
    );
  }

  return (
    <Link
      sx={{
        fontSize: '14px'
      }}
      onClick={onOpenDrawer}
      href="#"
    >
      Reschedule or cancel
    </Link>
  );
};
